








































import { Component, Vue } from 'vue-property-decorator';
import { format, formatDistance } from 'date-fns';
import { pl, enGB } from 'date-fns/locale';
import { workspaceService } from '@/services/WorkspaceService';
import EventBus from '@/EventBus';

@Component({
  props: ['type', 'id'],
})
export default class Logs extends Vue {
  workspaceId = 0;
  regionId = 0;
  virtualMachineId = 0;
  auditLogs = [];
  paginationNumbers: any = [];
  paginationData = {
    per_page: 20,
    page: 1,
    size: 0,
    total: 0,
  };
  lastPageNumber = 1;
  language = this.$root.$i18n.locale;

  formatDate(date: string) {
    return date ? format(new Date(date), 'HH:mm:ss  dd.MM.yyyy') : '';
  }

  descriptiveDateFormat(date: string) {
    return formatDistance(new Date(date), new Date(), {
      addSuffix: true,
      locale: this.language === 'pl' ? pl : enGB,
    });
  }

  getPaginationNumbers() {
    const pagesNumber = Math.ceil(this.paginationData.total / this.paginationData.per_page);

    if (pagesNumber > 7) {
      const tempNumbers: any = [];
      let startIndex = 1;
      if (this.paginationData.page > 4) {
        tempNumbers.push({ nr: this.paginationData.page - 3, label: '...' });
        startIndex = this.paginationData.page - 2;
      }
      for (let i = startIndex; i < this.paginationData.page; i += 1) {
        if (i > 0) {
          tempNumbers.push({ nr: i, label: i });
        }
      }
      tempNumbers.push({ nr: this.paginationData.page, label: this.paginationData.page * 1 });
      let addedPages = 0;
      for (let i = this.paginationData.page * 1 + 1; i <= pagesNumber; i += 1) {
        if (addedPages < 3) {
          addedPages += 1;
          tempNumbers.push({ nr: i, label: i });
        } else {
          tempNumbers.push({ nr: i, label: '...' });
          break;
        }
      }
      this.paginationNumbers = tempNumbers;
    } else {
      this.paginationNumbers = new Array(pagesNumber).fill(0).map((e, i) => {
        return { nr: i + 1, label: i + 1 };
      });
    }
  }

  setPage(nr: number) {
    const pagesNumber = Math.ceil(this.paginationData.total / this.paginationData.per_page);
    if (nr >= 0 && nr <= pagesNumber) {
      this.getLogs(nr);
    }
  }

  prevPage() {
    this.setPage(this.paginationData.page - 1);
  }

  nextPage() {
    this.setPage(this.paginationData.page + 1);
  }

  getLogs(page: number) {
    this.lastPageNumber = page;
    workspaceService.getLogs(this.$props.type, this.workspaceId, this.$props.id, page).then((data: any) => {
      this.auditLogs = data.logs;
      this.paginationData = data.pagination;
      this.getPaginationNumbers();
    });
  }

  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    this.virtualMachineId = parseInt(this.$route.params.virtualMachineId, 10);
    this.language = localStorage.getItem('locale') || this.$root.$i18n.locale;
    this.getLogs(1);
    EventBus.$on('update-current-audit-log-page', () => {
      this.getLogs(this.lastPageNumber);
    });
  }
}
